import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { I18nProvider } from '@/lib/i18n';
import { PreviewApp } from '@/PreviewApp';

import App from './App';
import './styles/globals.css';

const searchParams = new URLSearchParams(window.location.search);
const previewToken = searchParams.get('token');
const previewLevelId = searchParams.get('boardId');
const isPreviewMode = !!(previewToken && previewLevelId);

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found. Check index.html has <div id="root">.');

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      {isPreviewMode ? (
        // Preview mode: skip auth — token and boardId come from URL params
        <PreviewApp token={previewToken} levelId={previewLevelId} />
      ) : (
        <App />
      )}
    </I18nProvider>
  </StrictMode>,
);
